import DefaultAvatar from "./defaultAvatar.png";
import DefaultCustomer from "./defaultCustomer.png";
import LogoIcon from "./logo.png";
import CustomerImg from "./customerImg.png";

const Images = {
  DefaultAvatar,
  DefaultCustomer,
  LogoIcon,
  CustomerImg,
};

export { Images };
